import { createAction } from 'redux-actions';
import { PapiDeviation, PapiRequestDreamsofartGenerate } from '@wix/da-papi-types';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { DreamupFormModals } from '../../constants';
import { reduxKey } from './constants';
import { ArtStyle, SubmissionError, VariationSource } from './types';

export const reduxInitialized = createAction(`${reduxKey}.REDUX_INITIALIZED`, () => ({}));

export const initializeForm = createAction(
  `${reduxKey}.INITIALIZE_FORM`,
  (
    data: {
      restrictions;
      pointsPackages;
      defaultFormValues?: {
        promptStrength?: number;
      };
    },
    options: {
      initialPrompt: string;
      expandSettings: boolean;
      persistFromStorage: boolean;
    }
  ) => ({
    data,
    options,
  })
);

export const changePrompt = createAction(`${reduxKey}.CHANGE_PROMPT`, (prompt: string) => ({
  prompt,
}));

export const clearPrompt = createAction(`${reduxKey}.CLEAR_PROMPT`, () => ({}));

export const changeSimilarity = createAction(
  `${reduxKey}.CHANGE_SIMILARITY`,
  (similarity: number) => ({ similarity })
);

export const changePromptStrength = createAction(
  `${reduxKey}.CHANGE_PROMPT_STRENGTH`,
  (promptStrength: number) => ({ promptStrength })
);

export const changeAspectRatio = createAction(
  `${reduxKey}.CHANGE_ASPECT_RATIO`,
  (aspectRatio: NonNullable<PapiRequestDreamsofartGenerate['aspect_ratio']>) => ({
    aspectRatio,
  })
);

export const changeArtStyle = createAction(
  `${reduxKey}.CHANGE_ART_STYLE`,
  (artStyle: ArtStyle) => ({
    artStyle,
  })
);

/**
 * Sets up the UI and state to accept a variation generation request.
 */
export const startVariation = createAction(
  `${reduxKey}.START_VARIATION`,
  (
    deviation: PapiDeviation,
    options: {
      variationSource: VariationSource;
    }
  ) => ({ deviation, options })
);

/**
 * Clears the variation specific UI elements and state.
 */
export const clearVariation = createAction(`${reduxKey}.CLEAR_VARIATION`, () => ({}));

export const toggleNegativePrompt = createAction(`${reduxKey}.TOGGLE_NEGATIVE_PROMPT`, () => ({}));

export const changeNegativePrompt = createAction(
  `${reduxKey}.CHANGE_NEGATIVE_PROMPT`,
  (negativePrompt: string) => ({ negativePrompt })
);

/**
 * Shows a settings panel with advanced generation options
 */
export const showPromptSettingsPanel = createAction(
  `${reduxKey}.SHOW_PROMPT_SETTINGS_PANEL`,
  () => ({})
);

export const hidePromptSettingsPanel = createAction(
  `${reduxKey}.HIDE_PROMPT_SETTINGS_PANEL`,
  () => ({})
);

export const showStartingImageSelector = createAction(
  `${reduxKey}.SHOW_STARTING_IMAGE_SELECTOR`,
  () => ({})
);

export const hideStartingImageSelector = createAction(
  `${reduxKey}.HIDE_STARTING_IMAGE_SELECTOR`,
  () => ({})
);

export const generateFromPrompt = createAction(
  `${reduxKey}.GENERATE_FROM_PROMPT`,
  (usePoints: boolean) => ({
    usePoints,
  })
);

export const generationFromPromptInitiationSucceeded = createAction(
  `${reduxKey}.GENERATION_FROM_PROMPT_INITIATION_SUCCEEDED`,
  (generationId: number, imageCount: number, restrictions: any) => ({
    generationId,
    imageCount,
    restrictions,
  })
);

export const generationFromPromptInitiationFailed = createAction(
  `${reduxKey}.GENERATION_INITIATION_FAILED`,
  (error: SubmissionError, serverErrorMessage: string | undefined) => ({
    error,
    serverErrorMessage,
  })
);

/**
 * If any actions outside the form involve spending a resource (e.g. prompt, points), we need to update the value
 * over here.
 */
export const updateRestrictions = createAction(`${reduxKey}.UPDATE_RESTRICTIONS`, restrictions => ({
  restrictions,
}));

export const loadPersistentFormValues = createAction(
  `${reduxKey}.LOAD_PERSISTENT_FORM_VALUES`,
  () => ({})
);

export const storeFormValuesForRedirectPersistence = createAction(
  `${reduxKey}.STORE_FORM_VALUES_FOR_REDIRECT_PERSISTENCE`,
  () => ({})
);

export const pushPointsModal = () => pushModal(DreamupFormModals.POINTS, { wrapInModal: false });
